module.exports = {
	"Aggressive Allocation": 40,
	"China Region": 2,
	"Commodities Focused": 1,
	"Communications": 25,
	"Consumer Cyclical": 40,
	"Consumer Defensive": 16,
	"Derivative Income": 1,
	"Diversified Emerging Mkts": 8,
	"Diversified Pacific/Asia": 6,
	"Energy Limited Partnership": 26,
	"Equity Energy": 51,
	"Equity Precious Metals": 29,
	"Europe Stock": 36,
	"Financial": 51,
	"Foreign Large Blend": 272,
	"Foreign Large Growth": 119,
	"Foreign Large Value": 144,
	"Foreign Small/Mid Blend": 27,
	"Foreign Small/Mid Growth": 39,
	"Foreign Small/Mid Value": 30,
	"Global Allocation": 48,
	"Global Large-Stock Blend": 125,
	"Global Large-Stock Growth": 98,
	"Global Large-Stock Value": 61,
	"Global Real Estate": 55,
	"Global Small/Mid Stock": 57,
	"Health": 89,
	"Industrials": 45,
	"Infrastructure": 44,
	"Japan Stock": 24,
	"Large Blend": 605,
	"Large Growth": 398,
	"Large Value": 442,
	"Mid-Cap Blend": 202,
	"Mid-Cap Growth": 169,
	"Mid-Cap Value": 170,
	"Miscellaneous Region": 41,
	"Miscellaneous Sector": 32,
	"Moderate Allocation": 136,
	"Moderately Aggressive Allocation": 71,
	"Moderately Conservative Allocation": 1,
	"Natural Resources": 74,
	"Pacific/Asia ex-Japan Stk": 5,
	"Real Estate": 92,
	"Small Blend": 248,
	"Small Growth": 155,
	"Small Value": 165,
	"Tactical Allocation": 25,
	"Target-Date 2025": 4,
	"Target-Date 2030": 35,
	"Target-Date 2035": 40,
	"Target-Date 2040": 44,
	"Target-Date 2045": 46,
	"Target-Date 2050": 46,
	"Target-Date 2055": 46,
	"Target-Date 2060": 45,
	"Target-Date 2065+": 56,
	"Technology": 172,
	"Utilities": 25
};


//////////////////
// WEBPACK FOOTER
// ./src/data/GefScoreNormalizersPeers.json
// module id = 954
// module chunks = 0